import React, { useCallback, useContext, useEffect } from "react";
import { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { TostMsg } from "../../../../App";
import ComponentLoader from "../../../../Shared/Sidebar/ComponentLoader";
import {
  addEmployeeLanguage,
  addEmployeeSkills,
  deleteEmployeeLanguage,
  deleteEmployeeSkills,
  employeeLanguage,
  employeeSkills,
} from "../Service/profileService";
import {
  GetMasterTypeData,
} from "../../../../Services/Global-Services/GlobalServices";
import ERROR_LIST from "../../../../Services/Global-Services/Hadle_Errors";

function UserSkillAndLanguage({ employee, fetchEmployeeIdData, employeeId }) {
  const [skillsEditId, setSkillsEditId] = useState(0);
  const [Isloading, setIsloading] = useState(false);
  const [languagesEditId, setLanguagesEditId] = useState(0);
  const [showContent, setSeleteContent] = useState([]);
  const [employeeLanguageList, setEmployeeLanguageList] = useState();
  const toster = useContext(TostMsg);
  const [DeleteacademicId, setDeleteacademicId] = useState(null);
  const [DeleteLanguageId, setDeleteLanguageId] = useState(null);
  const [EmployeeSkillsList, setEmployeeSkillsList] = useState();
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
  const [selectedLang, setSelectedLang] = useState([]);
  const [selectedSkill, setSelectedSkill] = useState([]);
  const [selectedProficiency, setSelectedProficiency] = useState([]);
  useEffect(() => {
    if (employeeId) {
      getEmployeeSkills();
      getEmployeeLanguage();
      getMaster();
    }
  }, [employeeId]);

  const getMaster = async () => {
    let params1 = {
      masterType: "Language",
      allRecords: true,
      organisationId: userDetails?.OrgId,
    };
    let params2 = {
      masterType: "Skill",
      allRecords: true,
      organisationId: userDetails?.OrgId,
    };
    let params3 = {
      masterType: "Proficiency",
      allRecords: true,
      organisationId: userDetails?.OrgId,
    };
    try {
      let responce = await GetMasterTypeData(params1);
      setSelectedLang(responce?.Data);
    } catch (error) {
      toster.current.error(ERROR_LIST?.MasterDataType);
    }
    try {
      let responce = await GetMasterTypeData(params2);
      setSelectedSkill(responce?.Data);
    } catch (error) {
      toster.current.error(ERROR_LIST?.MasterDataType);
    }
    try {
      let responce = await GetMasterTypeData(params3);
      setSelectedProficiency(responce?.Data);
    } catch (error) {
      toster.current.error(ERROR_LIST?.MasterDataType);
    }
  };

  async function getEmployeeSkills() {
    const params = {
      Orgid: userDetails.OrgId,
      SkillId: 0,
      Empid: employeeId,
    };
    try {
      const response = await employeeSkills(params);
      let employeeSkillDatalist = response?.Data;
      setEmployeeSkillsList(employeeSkillDatalist);
    } catch (error) {
      setIsloading(false);
      toster.current.error(ERROR_LIST.DefaultError);
    }
  }

  async function getEmployeeLanguage() {
    const params = {
      OrgId: userDetails.OrgId,
      languageId: 0,
      EmpId: employeeId,
    };
    try {
      const response = await employeeLanguage(params);
      let employeeLanguageDatalist = response?.Data;
      setEmployeeLanguageList(employeeLanguageDatalist);
    } catch (error) {
      setIsloading(false);
      toster.current.error(ERROR_LIST.DefaultError);
    }
  }

  async function editSkill(skillDetails) {
    if (skillDetails) {
      setSkillsEditId(skillDetails?.Id);
      const editSkillData = {
        Id: skillDetails?.id,
        OrgId: userDetails.OrgId,
        EmpId: userDetails.EmpId,
        skill: skillDetails?.Skill,
        detail: skillDetails?.Detail,
        skillCategoryId: skillDetails?.SkillCategoryId ?? 0,
        ModifiedBy: userDetails.EmpId,
      };
      userSkillsForm.setValues(editSkillData);
    }
  }

  const SkillsValidation = Yup.object().shape({
    skill: Yup.string().required("Title is required."),
    detail: "",
    skillCategoryId: Yup.string().required("Skill type is required."),
  });

  const userSkillsForm = useFormik({
    initialValues: {
      skill: "",
      detail: "",
      skillCategoryId: "",
    },
    validationSchema: SkillsValidation,
    onSubmit: async (data) => {
      setIsloading(true);
      const body = {
        OrgId: userDetails.OrgId,
        EmpId: userDetails.EmpId,
        Id: data?.Id ?? 0,
        SkillCategoryId: data?.skillCategoryId,
        Skill: data?.skill,
        Detail: data?.detail,
        ModifiedBy: userDetails.EmpId,
      };
      try {
        await addEmployeeSkills(body);
        if (data?.Id) {
          GetMasterSystemAlertList("Skill_Updated", 0);
          setIsloading(false);
        } else {
          GetMasterSystemAlertList("Skill_Added", 0);
          setIsloading(false);
        }
        document.querySelector("#skills .btn-close")?.click();
        getEmployeeSkills();
        handleCloseSkillModal();
        setIsloading(false);
      } catch (err) {
        setIsloading(false);
        toster.current.error(ERROR_LIST.DefaultError);
      }
    },
  });

  const handleCloseSkillModal = () => {
    document.querySelector("#skills .btn-close")?.click();
    setSkillsEditId(0);
    userSkillsForm.resetForm();
  };

  const getOptionDisabled = (option) => {
    return employeeLanguageList?.some(
      (lang) =>
        lang.LanguageName.toLowerCase() === option.Name.toLowerCase() &&
        lang.OrgId === userDetails.OrgId &&
        lang.EmpId === userDetails.EmpId
    );
  };

  const LanguagesValidation = Yup.object().shape({
    proficiencyId: Yup.string().required("Proficiency is required."),
    languageName: Yup.string().required("Language is required."),
  });

  const userLanguagesForm = useFormik({
    initialValues: {
      proficiencyId: "",
      languageName: "",
    },
    validationSchema: LanguagesValidation,
    onSubmit: async (data) => {
      setIsloading(true);
      const body = {
        OrgId: data?.orgId ?? userDetails.OrgId,
        EmpId: data?.empId ?? userDetails.EmpId,
        Id: data?.Id ?? 0,
        ProficiencyId: data?.proficiencyId,
        LanguageName: data?.languageName,
        ModifiedBy: userDetails.EmpId,
      };
      let educationList = await addEmployeeLanguage(body);
      try {
        getEmployeeLanguage();
        if (data?.Id) {
          setIsloading(false);
          GetMasterSystemAlertList("Language_Updated", 0);
        } else {
          setIsloading(false);
          GetMasterSystemAlertList("Language__Added", 0);
        }
        document.querySelector("#language .btn-close")?.click();
        handleCloseLanguagesModal();
      } catch (error) {
        setIsloading(false);
      } finally {
        setIsloading(false);
      }
    },
  });

  const handleCloseLanguagesModal = () => {
    document.querySelector("#language .btn-close")?.click();
    setLanguagesEditId(0);
    userLanguagesForm.resetForm();
  };

  async function editLanguages(languagesDetails) {
    if (languagesDetails) {
      setLanguagesEditId(languagesDetails?.id);
      const editLanguagesData = {
        proficiencyId: languagesDetails?.ProficiencyId,
        languageName: languagesDetails?.LanguageName,
        orgId: languagesDetails?.OrgId,
        empId: languagesDetails?.EmpId,
        Id: languagesDetails?.id,
      };
      userLanguagesForm.setValues(editLanguagesData);
    }
  }

  const GetMasterSystemAlertList = useCallback(async (message, type) => {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message && type == 0) {
        toster.current.success(msg?.Desc);
      } else if (msg?.Name == message && type == 1) {
        setSeleteContent(msg?.Desc);
      } else if (msg?.Name == message && type == 2) {
        setSeleteContent(msg?.Desc);
      }
    });
  }, []);

  async function deleteAcademicDetails(event) {
    if (DeleteLanguageId?.type == "Languages") {
      let body = {
        Id: DeleteLanguageId?.language,
        ModifiedBy: userDetails.EmpId,
      };
      setIsloading(true);
      try {
        let experiencesList = await deleteEmployeeLanguage(body);
        if (experiencesList) {
          GetMasterSystemAlertList("Language_Deleted", 0);
          setIsloading(false);
          getEmployeeLanguage();
        }
      } catch (error) {
        toster.current.error(ERROR_LIST.DefaultError);
        setIsloading(false);
      }
    } else if (DeleteacademicId.type == "Skill") {
      let body = {
        Id: DeleteacademicId?.skill,
        ModifiedBy: userDetails.EmpId,
      };
      setIsloading(true);
      try {
        let skillsList = await deleteEmployeeSkills(body);
        if (skillsList) {
          getEmployeeSkills();
          GetMasterSystemAlertList("Skill__Deleted", 0);
          setIsloading(false);
        }
      } catch (error) {
        toster.current.error(ERROR_LIST.DefaultError);
        setIsloading(false);
      }
    }
  }

  const addSkills = () => {
    userSkillsForm.resetForm();
    setSkillsEditId(0);
  };
  const addLanguage = () => {
    userSkillsForm.resetForm();
    setLanguagesEditId(0);
  };

  return (
    <div>
      <div className="profile-about-me position-relation">
        <div className="pt-3 border-bottom-1">
          <div className="mb-0">
            <h4 className="text-primary mb-3 sumh4 addprofile-action">
              Skills
              {userDetails?.EmpId == employeeId && (
                <span>
                  <a
                    className="edit-btncss mb-2 love-icon"
                    title="Add Skills"
                    data-bs-toggle="modal"
                    data-bs-target="#skills"
                    aria-label="Skills"
                    onClick={() => {
                      addSkills();
                      GetMasterSystemAlertList("add_skill", 1);
                    }}
                  >
                    <img
                      src="/images/org-img/profile/add.png"
                      className="w-100"
                    />{" "}
                  </a>
                </span>
              )}
            </h4>

            <div className="languages-wrapper">
              {EmployeeSkillsList?.map((skill, index) => {
                return (
                  <div className="languages-item on-hover-icon" key={index}>
                    <div className="icon-wrap">
                      <img src="/images/org-img/profile/lang-1.png" />
                    </div>
                    <div className="meta">
                      <span className="dark-inverted">{skill?.Skill}</span>
                      <span>{skill?.SkillCategory}</span>
                    </div>

                    <div
                      className="hover-badges-box"
                      style={{ marginLeft: "auto" }}
                    >
                      {userDetails?.EmpId == employeeId && (
                        <button
                          onClick={() => {
                            editSkill(skill);
                            GetMasterSystemAlertList("edit_skill", 1);
                          }}
                          className="skill-actionbtn"
                          title="Edit"
                          data-bs-toggle="modal"
                          data-bs-target="#skills"
                        >
                          <img src="/images/org-img/edit.png" />
                        </button>
                      )}
                      {userDetails?.EmpId == employeeId && (
                        <button
                          onClick={() => {
                            setDeleteacademicId({
                              skill: skill?.id,
                              type: "Skill",
                            });
                            GetMasterSystemAlertList("Delete_Skills", 1);
                          }}
                          className="skill-actionbtn"
                          title="Delete"
                          data-bs-toggle="modal"
                          data-bs-target="#delete-edsl"
                        >
                          <img src="/images/org-img/delete.png" />
                        </button>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>

            <h4 className="text-primary mb-3 sumh4 mt-3  addprofile-action">
              Languages
              {userDetails?.EmpId == employeeId && (
                <span>
                  <a
                    className="edit-btncss mb-2 love-icon"
                    title="Add Language"
                    data-bs-toggle="modal"
                    data-bs-target="#language"
                    aria-label="Language"
                    onClick={() => {
                      addLanguage();
                      GetMasterSystemAlertList("Select_Language", 1);
                    }}
                    style={{
                      background: "#fbfbfb",
                      float: "right",
                    }}
                  >
                    <img
                      src="/images/org-img/profile/add.png"
                      className="w-100"
                    />
                  </a>
                </span>
              )}
            </h4>
            <div className="languages-wrapper">
              {employeeLanguageList?.map((languages, index) => {
                return (
                  <div  key={index} className="languages-item on-hover-icon">
                    <div className="icon-wrap ">
                      <img src={languages?.ProficiencyLogo} />
                    </div>
                    <div className="meta">
                      <span className="dark-inverted">
                        {languages?.LanguageName}
                      </span>
                      <span>{languages?.ProficiencyName}</span>
                    </div>
                    <div
                      className="hover-badges-box"
                      style={{ marginLeft: "auto" }}
                    >
                      {userDetails?.EmpId == employeeId && (
                        <button
                          onClick={() => {
                            editLanguages(languages);
                            GetMasterSystemAlertList("Select_Language", 1);
                          }}
                          className="skill-actionbtn"
                          title="Edit"
                          data-bs-toggle="modal"
                          data-bs-target="#language"
                        >
                          <img src="/images/org-img/edit.png" />
                        </button>
                      )}
                      {userDetails?.EmpId == employeeId && (
                        <button
                          onClick={() => {
                            setDeleteLanguageId({
                              language: languages?.id,
                              type: "Languages",
                            });
                            GetMasterSystemAlertList("Delete_Languages", 1);
                          }}
                          className="skill-actionbtn"
                          title="Delete"
                          data-bs-toggle="modal"
                          data-bs-target="#delete-edsl"
                        >
                          <img src="/images/org-img/delete.png" />
                        </button>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade custom-modal-area"
        tabIndex="-1"
        aria-hidden="true"
        id="skills"
      >
        <div className="modal-dialog modal-dialog-centered" role="skill">
          <div className="modal-content add-editeducation">
            <div className="modal-header">
              <img
                src="/images/org-img/leave/popup-backimg.png"
                className="backimg"
              />
              <div className="img">
                <img src="/images/popup-icons/featured-post.png" />
              </div>

              <button
                onClick={handleCloseSkillModal}
                type="button"
                className="btn-close m-auto"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body">
              <strong className="modal-title text-center">
                {skillsEditId != 0 ? (
                  <h5 className="modal-title m-auto">Edit Skill</h5>
                ) : (
                  <h5 className="modal-title m-auto">Add Skill</h5>
                )}
              </strong>
              <p className="text-center">{showContent}</p>
              <div className="addcourseform">
                <form onSubmit={userSkillsForm.handleSubmit}>
                  <div className="row">
                    <div className="mb-2 col-md-12">
                      <label className="form-label">
                        Title<i className="inValidError">*</i>
                      </label>
                      <input
                        type="text"
                        cols="1"
                        rows="4"
                        name="skill"
                        className={
                          "form-control" +
                          (userSkillsForm.errors.skill &&
                          userSkillsForm.touched.skill
                            ? " is-invalid"
                            : "")
                        }
                        onChange={userSkillsForm.handleChange}
                        value={userSkillsForm.values.skill}
                        placeholder="Skills title goes here..."
                      />
                      <div className="invalid-feedback">
                        {userSkillsForm.errors.skill &&
                        userSkillsForm.touched.skill
                          ? userSkillsForm.errors.skill
                          : null}
                      </div>
                    </div>

                    <div className="mb-2 col-md-12">
                      <label className="form-label">
                        Skill Type<i className="inValidError">*</i>
                      </label>
                      <select
                        id="inputState"
                        name="skillCategoryId"
                        className={
                          "form-control" +
                          (userSkillsForm.errors.skillCategoryId &&
                          userSkillsForm.touched.skillCategoryId
                            ? " is-invalid"
                            : "")
                        }
                        onChange={userSkillsForm.handleChange}
                        value={userSkillsForm.values.skillCategoryId}
                        placeholder="Skill"
                      >
                        <option value="" disabled selected>
                          Please Select...
                        </option>
                        {selectedSkill?.map((option) => (
                          <option key={option.Id} value={option?.Id}>
                            {option?.Name}
                          </option>
                        ))}
                      </select>
                      <div className="invalid-feedback">
                        {userSkillsForm.errors.skillCategoryId &&
                        userSkillsForm.touched.skillCategoryId
                          ? userSkillsForm.errors.skillCategoryId
                          : null}
                      </div>
                    </div>

                    <div className="mb-2 col-md-12">
                      <label className="form-label">Detail</label>
                      <textarea
                        rows={4}
                        col={1}
                        type="text"
                        name="detail"
                        className={"form-control h-auto"}
                        onChange={userSkillsForm.handleChange}
                        value={userSkillsForm.values.detail}
                        placeholder="Detail"
                      />
                    </div>
                  </div>
                  <div className="modal-footer m-auto justify-content-center">
                    <button
                      type="button"
                      className="cancelbtn-click"
                      data-bs-dismiss="modal"
                      onClick={handleCloseSkillModal}
                    >
                      Cancel
                    </button>
                    {skillsEditId != 0 ? (
                      <button
                        type="submit"
                        className="savebtn-click"
                        disabled={Isloading}
                      >
                        {Isloading ? "Please wait..." : "Update"}
                      </button>
                    ) : (
                      <button
                        type="submit"
                        className="savebtn-click"
                        disabled={Isloading}
                      >
                        {Isloading ? "Please wait..." : "Save"}
                      </button>
                    )}
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade custom-modal-area"
        tabIndex="-1"
        aria-hidden="true"
        id="language"
      >
        <div className="modal-dialog modal-dialog-centered" role="skill">
          <div className="modal-content add-editeducation">
            <div className="modal-header">
              <img
                src="/images/org-img/leave/popup-backimg.png"
                className="backimg"
              />
              <div className="img">
                <img src="/images/popup-icons/featured-post.png" />
              </div>
              <button
                onClick={handleCloseLanguagesModal}
                type="button"
                className="btn-close m-auto"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body ">
              <div className=" text-center">
                <div>
                  {languagesEditId != 0 ? (
                    <h5 className="modal-title">Edit Language</h5>
                  ) : (
                    <h5 className="modal-title">Add Language</h5>
                  )}
                </div>
                <p>{showContent}</p>
              </div>

              <div className="addcourseform">
                <form onSubmit={userLanguagesForm.handleSubmit}>
                  <div className="row gx-2">
                    <div className="mb-3 col-md-6">
                      <label className="form-label">
                        proficiency<i className="inValidError">*</i>
                      </label>
                      <select
                        id="inputState"
                        name="proficiencyId"
                        className={
                          "form-control" +
                          (userLanguagesForm.errors.proficiencyId &&
                          userLanguagesForm.touched.proficiencyId
                            ? " is-invalid"
                            : "")
                        }
                        onChange={userLanguagesForm.handleChange}
                        value={userLanguagesForm.values.proficiencyId}
                        placeholder="proficiency"
                      >
                        <option value="" disabled selected>
                          Please Select...
                        </option>
                        {selectedProficiency?.map((option) => (
                          <option key={option.Id} value={option.Id}>
                            {option.Name}
                          </option>
                        ))}
                      </select>
                      <div className="invalid-feedback">
                        {userLanguagesForm.errors.proficiencyId &&
                        userLanguagesForm.touched.proficiencyId
                          ? userLanguagesForm.errors.proficiencyId
                          : null}
                      </div>
                    </div>

                    <div className="mb-3 col-md-6">
                      <label className="form-label">
                        Language<i className="inValidError">*</i>
                      </label>
                      <select
                        id="inputState"
                        name="languageName"
                        className={
                          "form-control" +
                          (userLanguagesForm.errors.languageName &&
                          userLanguagesForm.touched.languageName
                            ? " is-invalid"
                            : "")
                        }
                        onChange={userLanguagesForm.handleChange}
                        value={userLanguagesForm.values.languageName}
                        placeholder="Language Name"
                      >
                        <option value="" disabled selected>
                          Please Select...
                        </option>
                        {selectedLang?.map((option) => (
                          <option
                            key={option.Id}
                            value={option.Name}
                            disabled={getOptionDisabled(option)}
                          >
                            {option.Name}
                          </option>
                        ))}
                      </select>
                      <div className="invalid-feedback">
                        {userLanguagesForm.errors.languageName &&
                        userLanguagesForm.touched.languageName
                          ? userLanguagesForm.errors.languageName
                          : null}
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer m-auto justify-content-center">
                    <button
                      type="button"
                      className="cancelbtn-click"
                      data-bs-dismiss="modal"
                      onClick={handleCloseLanguagesModal}
                    >
                      Cancel
                    </button>
                    {languagesEditId != 0 ? (
                      <button
                        type="submit"
                        className="savebtn-click"
                        disabled={Isloading}
                      >
                        {Isloading ? "Please wait..." : "Update"}
                      </button>
                    ) : (
                      <button
                        type="submit"
                        className="savebtn-click"
                        disabled={Isloading}
                      >
                        {Isloading ? "Please wait..." : "Save"}
                      </button>
                    )}
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="modal fade" id="delete-edsl">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content delete-holiday">
            <div className="modal-header">
              <img
                src="/images/org-img/leave/popup-backimg.png"
                className="backimg"
              />
              <div className="img">
                <img src="/images/org-img/leave/trash.png" />
              </div>
            </div>
            <div className="modal-body text-center">
              <strong className="modal-title">Are you sure?</strong>
              <p>{showContent}</p>
            </div>
            <div className="modal-footer m-auto">
              <button
                type="button"
                className="cancelbtn-click"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>
              <button
                type="button"
                className="deletebtn-click"
                data-bs-dismiss="modal"
                onClick={() => deleteAcademicDetails("delete")}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>
      {Isloading ? <ComponentLoader /> : ""}
    </div>
  );
}

export default UserSkillAndLanguage;
